import React from "react";
import { COLORS } from "./tokens";

/**
 * WALK FIGURE icon — the walking woman standalone.
 * Extracted from the Rona Walk logo where she is the "L" in WALK.
 * Perfect for embroidery, tags, tote bags, chest prints, apparel.
 * Bold silhouette. One color. Reads clean at any size.
 */
const WalkFigureIcon = React.forwardRef(function WalkFigureIcon(
  { size = 240, color = COLORS.gold, id = "walk-figure-icon" },
  ref
) {
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      width={size}
      height={size}
      role="img"
      aria-label="The Rona Walk — Walking Figure Icon"
    >
      <defs>
        <linearGradient id={`${id}-grad`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="1" />
          <stop offset="100%" stopColor={color} stopOpacity="0.85" />
        </linearGradient>
      </defs>

      {/* Centered walking figure - re-drawn for square viewBox */}
      <g stroke={`url(#${id}-grad)`} fill={`url(#${id}-grad)`}>
        {/* Head */}
        <circle cx="200" cy="70" r="22" />

        {/* Hair flowing back */}
        <path
          d="M188 60 C 168 55, 152 68, 148 88 C 145 100, 155 108, 168 105"
          fill="none"
          strokeWidth="7"
          strokeLinecap="round"
        />

        {/* Body — gentle curve suggesting motion */}
        <path
          d="M200 100
             C 208 145, 202 185, 195 225
             C 187 260, 184 278, 197 300"
          fill="none"
          strokeWidth="12"
          strokeLinecap="round"
        />

        {/* Back arm */}
        <path
          d="M197 155 C 175 180, 168 200, 175 222"
          fill="none"
          strokeWidth="9"
          strokeLinecap="round"
        />

        {/* Forward arm */}
        <path
          d="M204 158 C 224 178, 232 195, 228 218"
          fill="none"
          strokeWidth="9"
          strokeLinecap="round"
        />

        {/* Back leg (bent) */}
        <path
          d="M194 300 C 178 322, 168 345, 170 370"
          fill="none"
          strokeWidth="11"
          strokeLinecap="round"
        />

        {/* Forward leg (extended — the L's horizontal base) */}
        <path
          d="M200 300
             C 218 315, 245 325, 280 328
             C 305 330, 328 330, 348 328"
          fill="none"
          strokeWidth="11"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
});

export default WalkFigureIcon;
